import React, {PureComponent} from 'react';
import { Col, Container, Row } from 'reactstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import AssetsSummary from './components/AssetsSummary/AssetsSummary';
import AnalysisSummary from './components/AnalysisSummary';
import AnalysisTrend from './components/AnalysisTrend';
import HelthAssets from './components/HelthAssets';
import PredictionEvents from './components/PredictionEvents';
import {asset_summary, ai_analysis_summary,
     asset_components_with_health_issues,
     important_events_pending_review
} from "../../../new_dashboard_data";

import { loadDashboard} from "../../../redux/actions/dashboard";

class AssetDashboard extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loadingData: true,
        };
    };

    componentDidMount() {
        this.props.loadDashboard();
    }

    LoadingDashboardData = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> Loading Dashboard Data
        </div>
    );

    render() {
        const {t, rtl, dashboard } = this.props;
        const ai_analysis_trends = dashboard.ai_analysis_trends;
        console.log("dashboard:", dashboard);
        return (
            <Col>
              <Container className="dashboard">
                {dashboard ?
                <div>
                  <section id="content">
                      <Row>
                        <Col md={12}>
                          <h3 className="page-title">{t('dashboard_assets.page_title')}</h3>
                        </Col>
                      </Row>
                      <div className="row row-eq-height field">
                        <AssetsSummary assetSummaryData={dashboard.asset_summary} dir={rtl.direction} />
                        <AnalysisSummary summaryData={dashboard.ai_analysis_summary} />
                      </div>
                      <Row className="row-eq-height field graph">
                        {Object.keys(ai_analysis_trends).map((val, key)=>(
                            <Col lg={3} xs={12} sm={3} className="text-center">
                              <AnalysisTrend title={val} data={ai_analysis_trends[val]} />
                            </Col>
                        ))}
                      </Row>
                      <HelthAssets data={dashboard.asset_components_with_health_issues} />
                      <PredictionEvents data={dashboard.important_events_pending_review } />
                  </section>
                </div>
                :this.LoadingDashboardData()}
              </Container>
            </Col>
        );
    }
}

AssetDashboard.propTypes = {
  t: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
};


function mapStateToProps({
       dashboard,rtl
}) {
    return {
        dashboard,
        rtl
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadDashboard
        },
        dispatch
    );
}

export default withTranslation('common') (
    connect(
    mapStateToProps,
    mapDispatchToProps
    )(AssetDashboard)
);
